<template>

  <div>

    <Head :title="__('exam.manage')"/>

    <h1 class="h1">Info-Seite bearbeiten</h1>

    <div class="flex items-center justify-between mb-6">

      <div class="bg-white rounded-md shadow w-full">

        <div class="flex flex-wrap p-5 md:p-8 text-sm md:text-base">

          <div class="w-full">

            <textarea-input v-model="form.main" label="Inhalt" :rows="25"/>

            <div class="flex justify-end mt-4">

              <loading-button :loading="form.processing" @click="submit" class="btn-primary">

                Speichern

              </loading-button>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

import {Head} from '@inertiajs/inertia-vue3'

import Layout from '@/Shared/Layout'

import mapValues from 'lodash/mapValues'

import TextareaInput from '../../Shared/TextareaInput.vue'

import LoadingButton from '../../Shared/LoadingButton.vue'

export default {

  components: {

    TextareaInput,

    Head,

    LoadingButton,

  },

  layout: Layout,

  props: {

    content: {

      type: Object,

      required: true,

    },

  },

  data() {

    return {

      form: this.$inertia.form({

        main: this.content.main,

      }),

    }

  },

  methods: {

    reset() {

      this.form = mapValues(this.form, () => null)

    },

    submit() {

      this.form.put('/admin/info', this.form)

    },

  },

}

</script>